<script lang="ts">
	import type { TooltipProps } from '../types/props';
	import { tooltipAction } from '../actions';
	import { attrValue } from '../utils/html';
	import type { ComponentSizes } from '../types/props';
	import svg from '$lib/svg/svg-sprite.svg';

	export let name: string;
	export let size: ComponentSizes = 'default';
	export let outlined = false;
	export let classNames: string | null = null;
	export let tooltip: TooltipProps = {};
	export let disabled: boolean | undefined = undefined;
	export let handleMouseEnter: () => void | null = null;
	export let handleMouseLeave: () => void | null = null;

	$: tooltip = tooltip;
</script>

<svg
	class={attrValue(['fill-current flex-shrink-0', size, classNames])}
	class:outlined
	class:disabled
	on:click
	use:tooltipAction={tooltip}
	on:mouseenter={handleMouseEnter}
	on:mouseleave={handleMouseLeave}
>
	<use href="{svg}#{name}" />
</svg>

<style lang="postcss">
	.outlined {
		@apply stroke-current;
		fill: none;
		&:hover {
			@apply fill-current;
		}
	}

	.tiny {
		@apply w-2 h-2;
	}

	.small {
		@apply w-3 h-3;
	}

	.default:not(.w-full) {
		@apply w-4 h-4;
	}

	.big {
		@apply w-5 h-5;
	}

	.huge {
		@apply w-6 h-6;
	}
</style>
